<template>
    <div class="chartBox">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2 flexStart">
                <div style="color:#5cd9e8;margin-right: 10px;">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="flexStart">
                    <span class="fs-xl text mx-2" style="margin-right: 10px;">
                        学制分数统计
                    </span>
                    <dv-decoration-1 style="width:30%;height:1rem;" />
                    <div style="color:rgb(92, 217, 232);margin-left:10px;">总招生率：{{ waterConfig.data[0] }}%</div>
                </div>
            </div>
            <div class="d-flex jc-center body-box feeContainer" style="height:calc(100% - 30px);margin-top: 10px;">
                <div class="flexBetween tagBox">
                    <el-tag effect="plain" size="mini" v-for="(item, idx) in DataList" :key="idx"
                        :class="item.title == title ? 'chckd' : ''" @click="showScore(item)">{{ item.title }}</el-tag>
                </div>

                <div class="flex_1" style="overflow-y:auto;margin-top:10px;">
                    <table class="dtable scoredt" style="">
                        <tr>
                            <th colspan="9">
                                {{ config.title }}【计划：{{ config.plan }}】【招生：{{ config.score ? config.score.zscount : 0 }}】
                            </th>
                        </tr>

                        <tr>
                            <td style="width:200px">专业</td>
                            <td>招生计划</td>
                            <td>实招人数</td>
                            <td>平均分</td>
                            <td>最高分</td>
                            <td>最低分</td>
                            <td>已确认</td>
                            <td>已录取</td>

                        </tr>
                        <tr v-for="(m, i) in config.majors" :key="i">
                            <td>
                                {{ m.title }}
                            </td>
                            <td>
                                {{ m.item_plan }}
                            </td>
                            <td>
                                {{ m.score ? m.score.zscount : '' }}
                            </td>
                            <td>
                                {{ m.score ? m.score.avg : '' }}
                            </td>
                            <td>
                                {{ m.score ? m.score.max : '' }}
                            </td>
                            <td>
                                {{ m.score ? m.score.min : '' }}
                            </td>
                            <td>
                                {{ m.queren ? m.queren : '' }}
                            </td>
                            <td>
                                {{ m.fenban ? m.fenban : '' }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <!-- <xibuData :zsdata="config"></xibuData> -->
    </div>
</template>

<script>
import xibuData from "../../zs/majorscore.vue"
export default {
    props: ["waterConfig"],
    components: {
        xibuData
    },
    data() {
        return {
            DataList: [],
            config: [],
            title: '',
        };
    },


    mounted() { this.getList() },
    methods: {
        getList() {
            this.$http.post("/api/xuezhi_score_zstongji").then(res => {
                if (this.$store.state.pmid == 7 || this.$store.state.pmid == 12) {//玄武要其他的人数、昆山第一中专
                    this.$http.post("/api/get_xuezhi_stucount").then(res2 => {
                        for (let xz of res.data) {

                            for (let jf of res2.data.jiaofei) {
                                if (xz.title == jf.item_desc) {

                                    xz.jiaofei = jf.stu_count;
                                    break
                                }
                            }
                            for (let jf of res2.data.queren) {
                                if (xz.title == jf.item_desc) {
                                    xz.queren = jf.stu_count;
                                    break
                                }
                            }
                            for (let jf of res2.data.fenban) {
                                if (xz.title == jf.item_desc) {
                                    xz.fenban = jf.stu_count;
                                    break
                                }
                            }
                        }

                        this.DataList = res.data
                        this.$http.post("/api/get_zhuanye_stucount").then(res3 => {
                            for (let xz of res.data) {
                                for (let zy of xz.majors) {
                                    for (let jf of res3.data.jiaofei) {
                                        if (zy.title == jf.major_name) {
                                            zy.jiaofei = jf.stu_count;
                                            break
                                        }
                                    }
                                    for (let jf of res3.data.queren) {
                                        if (zy.title == jf.major_name) {
                                            zy.queren = jf.stu_count;
                                            break
                                        }
                                    }
                                    for (let jf of res3.data.fenban) {
                                        if (zy.title == jf.major_name) {
                                            zy.fenban = jf.stu_count;
                                            break
                                        }
                                    }
                                }



                            }
                            this.DataList = res.data
                            this.config = res.data[0];
                            this.title = res.data[0].title
                        })

                    })
                } else {
                    this.DataList = res.data
                    this.config = res.data[0];
                    this.title = res.data[0].title
                }

            })
        },
        showScore(e) {
            // console.log(e)
            this.config = e;
            this.title = e.title

        }
    },
};
</script>
<style lang="less" type="text/less">
.feeContainer {
    .dv-capsule-chart {
        padding-bottom: 0;

        .capsule-container {
            flex: 0 0 60%;
        }
    }

    .unit-label {
        div {
            color: #0d1224;

        }
    }

    .unit-text {
        color: #0d1224;
        //color: pink;
    }
}

.tagBox {
    .el-tag {
        background-color: transparent !important;
        color: #5cd9e8;
        border-color: rgb(92, 217, 232);
        cursor: pointer;
    }

    .chckd {
        background-color: rgb(92, 217, 232) !important;
        color: #fff;
    }
}
</style>
<style scope lang="less" type="text/less">
.chartBox {
    width: 100%;
    height: 100%;
}

.scoredt tr td {
    border: 1px solid #ccc;
}

.scoredt td {
    border: 1px solid #ccc;
}

.scoredt th {
    border: 1px solid #ccc !important;
}
</style>
